import { ApiMethod } from '@wajeez-web/stores/base';
import { AppWatch, appWatchClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export interface DateRangeRequest {
  fromDate?: string;
  toDate?: string;
}

export interface PlanRequest extends DateRangeRequest {
  plan: AppWatch.PlanType;
}

export interface ContentTypeRequest extends DateRangeRequest {
  contentType?: AppWatch.ContentType;
}
export const getWeeklyActiveUsers: ApiMethod<
  PlanRequest,
  AppWatch.WeeklyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.contentQueries_activeReadersWeeklyBreakdown_V1(
        data.fromDate,
        data.toDate,
        data.plan
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getMonthlyActiveUsers: ApiMethod<
  PlanRequest,
  AppWatch.MonthlyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.contentQueries_activeReadersMonthlyBreakdown_V1(
        data.fromDate,
        data.toDate,
        data.plan
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getDailyActiveUsersCount: ApiMethod<
  PlanRequest,
  AppWatch.DailyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_dailyActiveUsersCount_V1(
      data.fromDate,
      data.toDate,
      data.plan
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getUserActiveRetentionAfterFirstSession: ApiMethod<
  PlanRequest,
  AppWatch.UserWeeklyActiveOverallRetentionResponse[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.contentQueries_userActiveRetentionAfterFirstSession_V1(
        data.fromDate,
        data.toDate,
        data.plan
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getActiveUserCount: ApiMethod<
  DateRangeRequest,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_activeUsersCount_V1(
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getActiveUsersHourlyBreakdown: ApiMethod<
  DateRangeRequest,
  AppWatch.HourlyActiveReader[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_activeUsersHourlyBreakdown_V1(
      data.fromDate,
      data.toDate
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
export const getMostRatedContent: ApiMethod<
  ContentTypeRequest,
  AppWatch.BaseContentRow | null,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_mostRatedContent_V1(
      data.fromDate,
      data.toDate,
      data.contentType
    );
    if (response.success && response.data) {
      return response.data;
    } else {
      return null;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getMinutesListendToday: ApiMethod<void, number, any> = async (
  _,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_minutesListenedToday_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getContentTypeCount: ApiMethod<number, number, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_contentTypeCount_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getTopContent: ApiMethod<
  ContentTypeRequest,
  AppWatch.BaseContentRow,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response = await client.contentQueries_topContent_V1(
      data.fromDate,
      data.toDate,
      data.contentType
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getuserDetailedRetuntionAfterRegistration: ApiMethod<
  {
    UserId?: string;
    RetentionPeriod?: AppWatch.RetentionPeriod;
  },
  AppWatch.UserDetailedRetentionAfterRegistrationOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new AppWatch.AppWatch_ContentQueries_Client(
      undefined,
      appWatchClient
    );
    const response =
      await client.contentQueries_userDetailedRetentionAfterRegistration_V1(
        data.UserId,
        data.RetentionPeriod
      );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
